import * as actionTypes from './actionTypes';
import * as actions from './index';
import { format } from 'date-fns';

export const createDistStructure = (struct, type, parent = false) => {
    return async dispatch => {
		if(type && Array.isArray(struct)) {
            for(let i = 0; i < struct.length; i++) {
                let obj = struct[i];
           
                if(obj.meta) {
                    let dist = await window.flow.newDistproject(type, 0, obj.meta);
                    
                    if(dist && dist.data && dist.data.id) {
                        // add to parent
                        if(parent) {
                            let res = await window.flow.distprojectAddChild(parent, dist);
                        }
                    }
                    
                    // recursive call
                    if(obj.childs) {
                        dispatch(actions.createDistStructure(obj.childs, type, dist.data.id));
                    }
                }
            }
            if(!parent) {
                dispatch(actions.getDistributionByDistWithType(type));
            }
		}
    };
}


// get cdn log (called in pmdb/components/Admin/CDN/CDNLog.js:componentDidMount)
export const getCDNLog = () => {
    return (dispatch, getState) => {
        dispatch({ type: actionTypes.CDN_LOG_GET_START });
        window.flow.fileGet(getState().ui.config.CDN_LOG_FILE).then((res) => {
            //console.log(res);
            dispatch({ type: actionTypes.CDN_LOG_GET_SUCCESS, res: res });
        }).catch(res => {
            dispatch({ type: actionTypes.CDN_LOG_GET_FAIL });
        });
    }
}

// get cdn log (called in pmdb/components/Admin/CDN/CDNLog.js:componentWillUnmount)
export const resetCDNLog = () => {
    return (dispatch, getState) => {
        dispatch({ type: actionTypes.CDN_LOG_RESET });
    }
}

// check cdn status (called in pmdb/Layout/Layout.js:componentDidMount)
export const checkCDNStatus = () => {
    return (dispatch, getState) => {
        // state is needed for status bar
        let state = {};
        
        const runCheck = () => {
            window.flow.fileGet(getState().ui.config.CDN_STATUS_FILE)
                .then(res => JSON.parse(res.content))
                .then(obj => { 
                    if(state.running !== obj.running+"") {
                        state = { 
                            running: obj.running+"",
                            update: format(new Date(obj.update * 1000), getState().ui.config.dateFormat + " HH:mm")
                        }
                        const message = {
                            operation: "CDN UPDATE",
                            ...state
                        };
                        dispatch({ type: actionTypes.STATUSBAR_SET_MESSAGE, message: message });
                    }
                    
                })
                .catch(e => { console.log(e); /*clearInterval(interval)*/ });
        }
        runCheck();
        const interval = setInterval(runCheck, 120000);
    }
}

// flow.newDistproject("pmdb_pm", 0, { 'title': "2024", 'extra': 'year' });
// flow.distprojectAddNewChild(9442, "pmdb_pm", 0, { 'title': "Products", 'extra':"category" });
